import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  HttpUtils,
  PageableModel,
  PageableResponse,
  PageableService,
} from '@pwc-bei/common';
import { AuthenticationCookie, AuthenticationService } from '@pwc-bei/security';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IncentiveFaqResource } from '../models/api/incentiveFaq-resource';
import { IncentiveFaq } from '../models/incentiveFaq';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IncentiveFaqService extends PageableService<
IncentiveFaqResource,
IncentiveFaq
> {
  protected baseUrl: string = environment.apiUrl;
  protected endpoint: string = 'tls-fa-bandi/faq';

  constructor(
    http: HttpClient,
    private authenticationService: AuthenticationService,
    private translateService: TranslateService,
  ) {
    super(http);
  }

  convertResourceToModel(resource: IncentiveFaqResource): IncentiveFaq {
    return resource;
  }
  convertModelToResource(model: IncentiveFaq): IncentiveFaqResource {
    return model;
  }

  searchPost(
    search: Partial<IncentiveFaqResource>,
    forceHeader?: boolean,
  ): Observable<IncentiveFaqResource[]> {
    const pagination: Partial<PageableModel> = {
      page: search.page,
      size: search.size,
    };

    const params = HttpUtils.toHttpParams({
      ...pagination,
      sort: search.sort,
    });

    const headers = forceHeader ? this.getHeader() : undefined;

    return this.http
      .post(this.buildEndpointUrl('search'), search, { headers, params })
      .pipe(
        map((response: PageableResponse<IncentiveFaqResource[]>) =>
          this.extractPaginationInfo(response),
        ),
        map((list: IncentiveFaqResource[]): IncentiveFaq[] =>
          this.convertListToModel(list),
        ),
      );
  }
  private getHeader(): HttpHeaders {
    const currentUser: AuthenticationCookie =
      this.authenticationService.cookieValue;
    const lang =
      this.translateService.currentLang != null
        ? this.translateService.currentLang
        : 'it';
    let headers: HttpHeaders;
    if (currentUser && currentUser.access_token) {
      headers = new HttpHeaders({
        Authorization: `Bearer ${currentUser.access_token}`,
        'Accept-Language': `${lang.toLowerCase()}-${lang.toUpperCase()}`,
        'Content-Type': 'application/json',
      });
    }
    return headers;
  }

  public getCategories(): Observable<Array<string>> {
    const url = this.buildEndpointUrl('categories');
    return this.http.get<Array<string>>(url);
  }
}
